import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import ArrowForCheckbox from 'shared/ui/icons/ArrowForCheckbox';

import styles from './SettingsArrow.module.scss';

interface ISettingsArrowProps {
    checkboxName?: string;
    isOpen: boolean;
    onClick?: () => void;
}

const SettingsArrow: React.FC<ISettingsArrowProps> = ({checkboxName, isOpen, onClick}) => {
    const handleClick = onClick ?? (() => {
        const checkbox = document.querySelector(`input[name="${checkboxName}"]`) as HTMLInputElement | null;
        checkbox?.click();
    });

    return (
        <span
            className={cn(styles.icon, !isOpen && styles.collapsed)}
            onClick={handleClick}
            title={isOpen ? t`Скрыть настройки` : t`Показать настройки`}
        >
            <ArrowForCheckbox/>
        </span>
    );
};

export default SettingsArrow;
